// extracted by mini-css-extract-plugin
module.exports = {"notificationBox":"utils_notificationBox__35WkX"};